import { useMemo } from "react";

export const useParsedStoredPrompt = (storedPromptJson: string | object) => {
  return useMemo(() => {
    try {
      if (typeof storedPromptJson === "string") {
        return JSON.parse(storedPromptJson);
      } else if (
        typeof storedPromptJson === "object" &&
        storedPromptJson !== null
      ) {
        return storedPromptJson;
      }
    } catch (error) {
      console.warn("Failed to parse storedPromptJson", error);
    }
    return {};
  }, [storedPromptJson]);
};

export const resetPromptMessages = (
  chatData: any,
  setChatData: (updater: (prev: any) => any) => void
) => {
  const promptId = chatData?.prompts?.[0]?.prompt_message_id;

  if (!promptId) return;

  setChatData((prevData: any) => {
    if (!prevData) return null;

    // const updatedMessages =
    //   prevData.messages?.filter((m: any) => m.prompt_message_id !== promptId) ||
    //   [];

    return {
      ...prevData,
      messages: [],
    };
  });
};
